export default "__VITE_ASSET__hpFR_sQ4__"